module.exports = __webpack_public_path__ + "static/media/ico_search.486dd96e.svg";